module.exports = __webpack_public_path__ + "img/23.e9961838.png";